import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['The Sunday-night scramble: another session to invent from a blank page', 'Running the same three drills because there was no time to plan new ones', 'Kids getting bored, then restless, while they wait in line for the box', 'Two students who “can’t do the kong” yet — and nothing ready to give them instead', 'Searching forums for a year-long curriculum you can actually run', 'Fifteen kids, one vault box, and a queue that unravels the whole class', 'A school hall with no rails, and a plan that needed them', 'Scared first-timers and your strongest student in the same session'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-navy-deep" data-id="element-137" data-mp="17or5rgiwru92">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-138" data-mp="363vjakkrs78s">
        <div className="text-center" data-id="element-139" data-mp="363c3b9eojsxe">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-140" data-mp="322aababcwd3v">
            The coaching reality
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-141" data-mp="3g81yzvv10w7m">
            If you coach parkour, you know at least{' '}
            <span className="text-crimson-soft" data-id="element-142" data-mp="37a82okx9i2kg">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-143" data-mp="3baa7v427he4h">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-navy-line bg-navy-card px-4 py-4 text-sm text-white/85" data-id="element-144" data-mp="2wjen1hn7hog">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-crimson/20" data-id="element-145" data-mp="3q70zus9jvnk2">
                <XIcon className="h-3 w-3 text-crimson-soft" aria-hidden="true" data-id="element-146" data-mp="3u6i5pmsw2mpr" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display uppercase text-2xl sm:text-3xl text-gold leading-tight" data-id="element-147" data-mp="qlcfncd4gfpx">
          How many more classes do you want to plan from scratch?
        </p>
      </div>
    </section>;
}